export default 'M24 12a2 2 0 01-2 2H2a2 2 0 110-4h20a2 2 0 012 2z';